import { useEffect, useRef, useState } from "react";
import { itx } from "../translationItx/itx";
import { ConnectionType } from "../models/Connection";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";

export default function OnBoardingElement(props: {}) {
  const {} = props;

  // const [indexOpenState, setIndexOpenState] = useState<number>(calculateDefaultOpenIndex());

  const drawnIndex = useRef<number>(calculateDefaultOpenIndex());
  const redrawIndex = useRef<number>(0);
  const [contentItems, setContentItems] = useState<Array<any>>(new Array<any>());

  useEffect(() => {
    createContentItems();
    const timer = startTimerForWatchingChanges();
    return () => clearInterval(timer);
  }, []);

  // the step titles/texts below are computed once into contentItems, so recreate them
  // whenever the UI language changes, otherwise they stay in the previous language
  useOnChangeWatcher(state.languageVersion, () => {
    createContentItems();
    return false;
  });

  function Header(props: {}) {
    const {} = props;
    const firstName = state.loggedInUser.name.split(" ")[0] || "";
    return (
      <div style={{ textAlign: "left", justifyContent: "flex-start", fontSize: "24px", marginBottom: "20px" }}>
        {itx("headerTitle", "Hi T1, lass uns loslegen", { T1: firstName })}
      </div>
    );
  }
  function ListDropDownElement(props: { title: string; children: any; indexOpen: number }) {
    const { title, children, indexOpen } = props;
    const [isOpen, setIsOpen] = useState<boolean>(indexOpen === drawnIndex.current);
    if (!isOpen && indexOpen === drawnIndex.current) {
      setIsOpen(indexOpen === drawnIndex.current);
    }

    function toggleOpen() {
      setIsOpen(!isOpen);
    }

    return (
      <div
        key={title}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          width: "100%",
          textAlign: "left",
          justifyContent: "flex-start",
          border: "1px solid var(--primary-color)",
          borderRadius: "10px",
          boxShadow: "var(--panel-shadow)",
          backgroundColor: "var(--panel-background)",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            backgroundColor: "var(--primary-color)",
            padding: "5px",
            borderRadius: isOpen ? "8px 8px 0px 0px" : "8px",
          }}
          onClick={toggleOpen}
        >
          <i
            style={{ marginRight: "5px" }}
            onClick={toggleOpen}
            className={isOpen ? "las la-caret-down" : "las la-caret-right"}
          />
          {title}
        </div>
        <div style={{ padding: isOpen ? "10px" : undefined, paddingLeft: isOpen ? "25px" : undefined }}>
          {isOpen ? children : null}
        </div>
      </div>
    );
  }
  function VideoElement(props: {
    videolink?: string;
    videoIdFromYoutube?: string;
    title: string;
    videoName?: string;
    videoPicture?: string;
  }) {
    const { videolink, videoIdFromYoutube, title, videoName, videoPicture } = props;
    if (videoIdFromYoutube) {
      return (
        <div key={title} style={{ marginTop: "10px", marginBottom: "10px", textAlign: "center" }}>
          <iframe
            width="75%"
            height="315"
            src={`https://www.youtube.com/embed/${videoIdFromYoutube}`}
            title={title}
            allowFullScreen
          ></iframe>
        </div>
      );
    } else if (videolink) {
      return (
        <div key={title} style={{ marginTop: "10px", marginBottom: "10px", textAlign: "center", paddingTop: "50px" }}>
          <video
            width="75%"
            title={title}
            src={videolink}
            controls
            poster={videoPicture ? `/images/onBoarding/${videoPicture}` : undefined}
            style={{ border: "1px solid grey", boxShadow: "0 0 0.25cm rgba(0, 0, 0, 0.5)" }}
          >
            {/* {" "}
            <source src={videolink} type="video/mp4" /> */}
          </video>
        </div>
      );
    } else {
      return null;
    }
  }
  function ContentItem(props: {
    text: string;
    videolink?: string;
    videoIdFromYoutube?: string;
    videoName?: string;
    videoPicture?: string;
  }) {
    const { text, videolink, videoIdFromYoutube, videoName, videoPicture } = props;
    const textElements = new Array<any>();
    const textRows = text.split("\n");
    textRows.forEach((row, index) => {
      textElements.push(
        <div key={"textRow_" + index} style={{ marginTop: index == 0 ? "0px" : "5px" }}>
          {row.replace("\n", "")}
        </div>,
      );
    });
    return (
      <div key={text}>
        <div style={{ display: "flex", flexDirection: "column" }}>{textElements}</div>
        <VideoElement
          videolink={videolink}
          videoIdFromYoutube={videoIdFromYoutube!}
          title={videoName || ""}
          videoName={videoName}
          videoPicture={videoPicture}
        />
      </div>
    );
  }
  function calculateDefaultOpenIndex(): number {
    if (state.floors.size == 0 || state.allRooms().length == 0) {
      return 0;
    } else if (state.allConnections.getAll().filter((c) => c.type != ConnectionType.Button).length == 0) {
      return 1;
    } else if (state.allGroupAddresses(true).length == 0) {
      return 2;
    } else if (state.allScenes().length == 0) {
      return 3;
    } else {
      return 4;
    }
  }
  function startTimerForWatchingChanges() {
    /////////////////////////////////////////////////////
    // here set a loop with a timer to watch for changes in floors, rooms, connections, groupaddresses and scenes
    //
    return setInterval(() => {
      if (drawnIndex.current !== calculateDefaultOpenIndex()) {
        redrawIndex.current += 1;
        createContentItems(redrawIndex.current);
      }
      drawnIndex.current = calculateDefaultOpenIndex();
    }, 10000);
  }

  function createContentItems(redraw?: number) {
    const content = new Array<any>();
    const contentArray = [
      {
        indexOpen: 0, // needet to automaticaly open the current step
        title: itx("onboardingElement.step1", "Erstelle eine Etage und füge Räume hinzu"),
        redraw: redraw || redrawIndex.current,
        content: (
          <ContentItem
            text={itx(
              "onboardingElement.step1Text",
              "Sieh dir an, wie du deinen Grundriss als Etage anlegst und die Räume hinzufügst. (2:41 Min)",
            )}
            videolink="https://videos.files.wordpress.com/ju3okkyr/etagenplaene.mp4"
            videoName="KNX Planung mit Grundrissen"
            videoPicture="tutorialPlanenMitGrundrissen.jpg"
          />
        ),
      },
      {
        indexOpen: 1,
        title: itx("onboardingElement.step2", "Platziere Verbraucher und steuere sie mit Tastern"),
        redraw: redraw || redrawIndex.current,
        content: (
          <ContentItem
            text={itx(
              "onboardingElement.step2Text",
              " Erfahre wie du Lichter und Jalousien in einem Raum oder einer Etage platzierst und sie mit einem Taster verbindest.\n Die Parametrisierung erfolgt automatisch, die Tastenbelegung kann dynamisch verändert werden. (3:23 Min)",
            )}
            videolink="https://videos.files.wordpress.com/1pdNM1jg/parametrisierung-taster.mp4"
            videoName="Parametrierung eines KNX-Taster mit ESTADA"
            videoPicture="tutorialSchalterParametrieren.jpg"
          />
        ),
      },
      {
        indexOpen: 2,
        title: itx("onboardingElement.step3", "Generiere Gruppenadressen"),
        redraw: redraw || redrawIndex.current,
        content: (
          <ContentItem
            text={itx(
              "onboardingElement.step3Text",
              "Erstelle strukturierte Gruppenadressen mit einem Klick.\n Wir zeigen dir mit welchem Schema wir Gruppenadressen für dich generieren und wie du eigene Gruppenadressen erstellen kannst. (1:07 Min)",
            )}
            videolink="https://videos.files.wordpress.com/QWge6NKN/gruppenadressen-generieren-2.mp4"
            videoName="KNX Gruppenadressen mit ESTADA generieren"
            videoPicture="tutorialGruppenadressenErstellen.jpg"
          />
        ),
      },
      {
        indexOpen: 3,
        title: itx("onboardingElement.step4", "Erstelle Szenen"),
        redraw: redraw || redrawIndex.current,
        content: (
          <ContentItem
            text={itx(
              "onboardingElement.step4Text",
              "Erstelle im Handumdrehen Szenen und erfahre, wie du unterschiedliche Verbraucher und Taster mit Ihr verbindest, ganz ohne Parametrisierung der Aktoren.(2:09 Min)",
            )}
            videolink="https://videos.files.wordpress.com/lHU0EbLB/szenen.mp4"
            videoName="KNX-Szenen erstellen mit dem ESTADA Planungstool"
            videoPicture="tutorialSzenenErstellen.jpg"
          />
        ),
      },
      {
        indexOpen: 4,
        title: itx("onboardingElement.step5", "Exportiere das Projekt zu ETS"),
        redraw: redraw || redrawIndex.current,
        content: (
          <ContentItem
            text={itx(
              "onboardingElement.step5Text",
              "Erfahre wie du dein fertiges Projekt zu ETS exportieren und pushen kannst, um dein Projekt in Betrieb zu nehmen.",
            )}
            // videoIdFromYoutube="RlLW5OmCnsw"
            // videoName="Exportiere das Projekt zu ETS"
          />
        ),
      },
    ];
    contentArray.forEach((item, index) => {
      content.push(
        <ListDropDownElement
          title={item.title}
          indexOpen={item.indexOpen}
          key={"onBoardingElement_" + item.redraw + "_" + index}
        >
          {item.content}
        </ListDropDownElement>,
      );
      content.push(<div key={`onBoardingSpacer_${item.indexOpen}`} style={{ height: "5px" }}></div>);
    });
    setContentItems(content);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "left", width: "50%", marginLeft: "150px" }}>
      <Header />
      {contentItems}
    </div>
  );
}
